<template>
  <div class="footer">
    <h2 v-text="this.$store.state.siteName"></h2>
    <nav class="footer-btn">
      <router-link :to="{path:'/main',query:{c:'Centiare', centiare:'THOUSAND', contentID: 13}}">1000平方米展厅资料</router-link>
      <router-link :to="{path:'/main',query:{c:'Centiare', centiare:'FIVE_HUNDRED', contentID: 30}}">500平方米展厅资料</router-link>
      <el-button v-if="this.$store.state.isLogin" type="text" @click="dialogFeedbackVisible = true">问题反馈</el-button>
    </nav>
    <div class="wx">
      <img src="@/assets/images/wx.jpg" alt="">
      <p>如果您需要技术支持，请扫码添加微信。</p>
      <p>工作时间：周一至周五 09:00-18:00</p>
    </div>
    <el-dialog customClass="login-form" title="问题反馈" :visible.sync="dialogFeedbackVisible" :append-to-body="true" width="500px" :center="true" :before-close="handleFeedbackClose">
      <el-form :model="feedbackForm" label-width="100px" :rules="feedbackFormRules" ref="feedbackForm">
        <el-form-item label="联系方式：" prop="contactWay">
          <el-input type="text" v-model="feedbackForm.contactWay" placeholder="请输入联系方式" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="问题类型：" prop="type">
          <el-select v-model="feedbackForm.type" placeholder="请选择问题类型">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="问题描述：" prop="content">
          <el-input type="textarea" v-model="feedbackForm.content" placeholder="请详细描述需要反馈的问题" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFeedbackForm('feedbackForm')">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { feedbackSubmit } from '@/api/feedback'
export default {
  name: 'Footer',
  data() {
    return {
      dialogFeedbackVisible: false,
      feedbackForm: {
        contactWay: '',
        type: '',
        content: '',
        statusDictId: 6
      },
      feedbackFormRules: {
        contactWay: [
          { required: true, message: '请输入联系方式', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择问题类型', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入问题描述', trigger: 'blur' }
        ],
      },
      options: [{
        value: '1',
        label: '展馆资料问题'
      }, {
        value: '2',
        label: '资料库网站问题'
      }, {
        value: '3',
        label: '其他问题'
      }],
    }
  },
  methods: {
    // 提交问题反馈
    submitFeedbackForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          feedbackSubmit(this.feedbackForm).then(res => {
            console.log(res)
            if(res.data.code == 200){
              this.$refs[formName].resetFields()
              this.dialogFeedbackVisible = false
              this.$message({
                message: '提交成功',
                type: 'success'
              })
            }
          })
        } else {
          console.log('error submit!!')
          return false;
        }
      })
    },
    // 关闭问题反馈
    handleFeedbackClose(done){
      this.$refs['feedbackForm'].resetFields()
      this.dialogFeedbackVisible = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer {
  width: 100%;
  background: #a70004;
  padding: 50px 0 60px;
  text-align: center;
  position: relative;
}
.footer h2 {
  font-size: 30px;
  color: #ffd79c;
  font-weight: normal;
  padding-bottom: 30px;
}
.footer-btn a,.footer-btn .el-button {
  color: #fff;
  font-weight: normal;
  font-size: 18px;
  margin: 0 15px;
}
.wx {
  position: absolute;
  right: 50px;
  top: 20px;
}
.wx p {
  color: #fff;
  font-size: 14px;
  padding-top: 10px;
}
.wx img {
  width: 100px;
  height: 100px;
}
</style>
<style>
.login-form .el-select {
  width: 100%;
}
</style>
